<template>
  <div style="background: #f6f8f8" id="MarkExampapers" v-loading="loading" :element-loading-text="loadingText">
    <div style="width: 100%; height: 78px"></div>
    <div class="dialog_title">
      <div class="t_center">
        <div class="left_logo">
          <span><img class="logo" :src="logoImageUrl" alt="" />{{ title }}</span>
          <span class="left_border">评阅试卷</span>
        </div>
        <span class="exit_mark" @click="closeMark"><i class="i_exit"></i><span>退出评阅</span></span>
      </div>
    </div>
    <!-- 滚动区域 -->
    <div class="exam_centre">
      <div class="left_box container" ref="container" @scroll="handleScroll" :style="{ height: scrollHeight + 'px' }">
        <!-- 试卷标题 -->
        <div class="exam_title white_bg">
          {{ examPaper.title }}
          <ul>
            <li>
              <span>满分{{ examPaper.totalScore }}分</span>
            </li>
            <span></span>
            <li>
              <span>及格{{ examPaper.passingScore }}分</span>
            </li>
            <li>
              <span>限时{{ examPaper.timeing }}分钟</span>
            </li>
          </ul>
        </div>
        <!-- 这里是要吸顶的元素 -->
        <div class="que_type white_bg" ref="stickyElement" :style="stickyStyle">
          <ul :style="borderBlue">
            <li v-for="type in typeList" :key="type.orders" @click="scrollToSection(type.orders)"
              :class="{ active: activeTab === type.orders }">
              {{ convertToChineseNumeral(type.orders) }}、{{ type.typeStr }}
            </li>
          </ul>
          <div class="gray_box" v-if="grayBoxShow"></div>
        </div>
        <div class="question_content white_bg" :style="{
          marginTop: grayBoxShow
            ? stickyHeight + 98 + 'px'
            : stickyHeight + 'px',
        }">
          <!-- 这里是内容区域 -->
          <div class="wrapper">
            <div v-for="section in subjectsList" :key="section.key.orders" ref="itemRefs"
              :id="'section-' + section.key.orders">
              <p style="margin-top: 20px">
                {{ convertToChineseNumeral(section.key.orders) }}、{{
                  section.key.title
                }}
              </p>

              <div class="single_choice question_li">
                <div v-viewer>
                  <div v-for="(it, inx) in section.value" :key="inx">
                    <!-- 单选、多选、判断题型-->
                    <div v-if="(it.types === 1 || it.types === 2 || it.types === 4)">
                      <SelectsType :item="it" :subjectType="it.types"></SelectsType>
                    </div>
                    <!-- 完形填空、阅读理解 -->
                    <div v-if="(it.types === 9 || it.types === 10)">
                      <ReadingsType :item="it" :subjectType="it.types"></ReadingsType>
                    </div>
                    <!-- 填空题、选词填空 -->
                    <div v-if="(it.types === 3 || it.types === 11)">
                      <ProgrammesType :item="it" :subjectType="it.types">
                      </ProgrammesType>
                    </div>
                    <!-- 问答题、计算题、翻译题、作文题-->
                    <div v-if="(it.types === 5 || it.types === 6 || it.types === 7 || it.types === 8)">
                      <AnswersType :item="it" :subjectType="it.types"></AnswersType>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="right_box white_bg">
        <ul class="student_score">
          <li>
            <div>{{ examPaper.studentName }}</div>
            <div>考生</div>
          </li>
          <li>
            <div class="red_font">{{ userScore }}分</div>
            <div>总得分</div>
          </li>
        </ul>
        <div class="checkbox">
          <el-tooltip placement="top">
            <div slot="content" class="tip" style="width: 300px; liine-height: 46px">
              <p>是否向考生公布当前考评评阅结果</p>
              <p>勾选：在提交评阅后考生就能直接查阅考试评阅结果</p>
              <p>
                不勾选：在提交评阅后需要再后台【公布考试结果】考生才能查阅评阅结果
              </p>
            </div>
            <el-checkbox v-model="isPush" class="two_checkbox">是否公布</el-checkbox>
          </el-tooltip>
          <el-tooltip placement="top">
            <div slot="content" class="tip" style="width: 300px; liine-height: 46px">
              <p>
                勾选：在提交评阅后系统会自动向考生推送【考试结果微信提醒消息】
              </p>
              <p>不勾选：将不会向考生自动推送微信提醒消息</p>
            </div>
            <el-checkbox v-model="isSendWxMsg" class="two_checkbox">是否发送微信消息</el-checkbox>
          </el-tooltip>
        </div>
        <!-- 答题卡 -->
        <div class="answer_sheet">
          <div v-for="(item, index) in subjectsList" :key="index" @click="scrollToSection(item.key.orders)">
            <div class="ans_title">
              <div>
                {{ item.key.typeStr }}（得分：<span class="red_font">{{
                  item.subTeacherScoreTotal
                }}</span>分 ）
              </div>
            </div>
            <ul class="ans_card">
              <li v-for="li in item.value" :key="li.orders">
                <div>{{ li.orders }}</div>
                <div>{{ li.teacherScore }}分</div>
              </li>
            </ul>
          </div>
        </div>
        <!-- 按钮 -->
        <div class="ft_btn">
          <el-tooltip placement="top">
            <div slot="content" class="tip">
              友情提示：<br />提交评阅:只提交当前考试试卷评阅结果,如果当前考试试卷还未公布结果,系统将暂不公布考试结果
            </div>
            <el-button @click="submintMark">提交评阅</el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <!-- 退出评阅弹窗 -->
    <el-dialog title="退出评阅？" center :visible.sync="dialogVisible" width="25%" top="18vh" :show-close="false">
      <div style="text-align: center">
        亲，退出评阅将不会保存当前评阅记录哦！
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="exit">退出</el-button>
        <el-button type="primary" @click="dialogVisible = false">继续评阅</el-button>
      </span>
    </el-dialog>
    <!-- 考评评阅确认说明 -->
    <el-dialog title="考评评阅确认说明" center :visible.sync="dialogResult" width="40%">
      <div style="font-size: 16px; line-height: 28px">
        <div>
          1、当前答题评阅结果总分为[<span style="color: red">{{
            userScore
          }}</span>分]
        </div>
        <p>
          2、{{
            isPush ? "同时向考生公布考试评阅结果" : "暂不向考生公布考试评阅结果"
          }}
        </p>
        <p>
          3、{{
            isSendWxMsg
            ? "同时向考生自动推送考试结果微信提醒消息"
            : "暂不向考生自动推送考试结果微信提醒消息"
          }}
        </p>
        <p style="color: red">
          注：评阅结果提交成功后需要手动刷新后台【考试记录列表页】才能更新考试状态！
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogResult = false">取消</el-button>
        <el-button type="primary" v-if="!isDisabled" :disabled="isDisabled" @click="postDataMark">确定!</el-button>
        <el-button type="primary" v-else disabled>提交中<i class="el-icon-loading"></i></el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getReviewedsExamination,
  postReviewedsExamination,
} from "network/exam";
import { convertToChineseNumeral } from "common/utils";
import SelectsType from "./component/SelectsType";
import ReadingsType from "./component/ReadingsType";
import ProgrammesType from "./component/ProgrammesType";
import AnswersType from "./component/AnswersType";
import { defaultThemeStyle } from "common/const";

export default {
  name: "MarkExampapers",
  components: {
    SelectsType,
    ReadingsType,
    ProgrammesType,
    AnswersType,
  },
  data() {
    return {
      isDisabled: false,
      radio: "1", //是否评分
      scrollHeight: document.body.clientHeight - 88, //滚动高度
      container: null, // 获取滚动容器
      scrollPosition: 0,
      itemHeight: [],
      stickyStyle: { position: "absolute" }, //初始位置
      stickyHeight: 68,
      borderBlue: {
        borderBottom: "1px solid #ebeced",
        width: "864px",
        margin: "20px 20px 0 20px",
      },
      grayBoxShow: false, //是否展示吸顶后右侧灰色
      dialogVisible: false, //退出评阅弹窗
      score: 0,
      activeTab: 1,
      examPaper: {}, //试卷内容
      typeList: [], //题目类型
      subjectsList: [], //试卷下试题组
      isPush: true, //是否公布
      isSendWxMsg: true, //是否发送微信消息
      examinationStudentId: "",
      arrtypes1: [],
      arrtypes2: [],
      arrtypes3: [],
      arrtypes4: [],
      arrtypes5: [],
      arrtypes6: [],
      arrtypes7: [],
      arrtypes8: [],
      arrtypes9: [],
      arrtypes10: [],
      arrtypes11: [],
      dialogResult: false,
      loading: false,
      loadingText: 'loading...'
    };
  },
  computed: {
    logoImageUrl() {
      if (this.$store.state.allConfig) {
        return this.$store.state.allConfig.logoAdminImageUrl;
      } else if (sessionStorage.getItem("allConfig")) {
        return JSON.parse(sessionStorage.getItem("allConfig"))
          .logoAdminImageUrl;
      } else {
        return "";
      }
    },
    title() {
      if (this.$store.state.allConfig) {
        return this.$store.state.allConfig.projectName;
      } else if (sessionStorage.getItem("allConfig")) {
        return JSON.parse(sessionStorage.getItem("allConfig")).projectName;
      } else {
        return "";
      }
    },
    userScore() {
      const paseint = /^\+?[1-9][0-9]*$/; //正整数
      if (this.subjectsList && this.subjectsList.length > 0) {
        this.subjectsList.forEach((e) => {
          if (e.key.types == 1) {
            let teacherScore1 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore1 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore1) && teacherScore1 > 0
              ? (e.subTeacherScoreTotal = (teacherScore1 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore1);
          }
          if (e.key.types == 2) {
            let teacherScore2 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore2 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore2) && teacherScore2 > 0
              ? (e.subTeacherScoreTotal = (teacherScore2 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore2);
          }
          if (e.key.types == 3) {
            let teacherScore3 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore3 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore3) && teacherScore3 > 0
              ? (e.subTeacherScoreTotal = (teacherScore3 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore3);
          }
          if (e.key.types == 4) {
            let teacherScore4 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore4 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore4) && teacherScore4 > 0
              ? (e.subTeacherScoreTotal = (teacherScore4 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore4);
          }
          if (e.key.types == 5) {
            let teacherScore5 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore5 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore5) && teacherScore5 > 0
              ? (e.subTeacherScoreTotal = (teacherScore5 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore5);
          }
          if (e.key.types == 6) {
            let teacherScore6 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore6 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore6) && teacherScore6 > 0
              ? (e.subTeacherScoreTotal = (teacherScore6 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore6);
          }
          if (e.key.types == 7) {
            let teacherScore7 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore7 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore7) && teacherScore7 > 0
              ? (e.subTeacherScoreTotal = (teacherScore7 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore7);
          }
          if (e.key.types == 8) {
            let teacherScore8 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore8 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore8) && teacherScore8 > 0
              ? (e.subTeacherScoreTotal = (teacherScore8 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore8);
          }
          if (e.key.types == 9) {
            let teacherScore9 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore9 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore9) && teacherScore9 > 0
              ? (e.subTeacherScoreTotal = (teacherScore9 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore9);
          }
          if (e.key.types == 10) {
            let teacherScore10 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore10 += Number(i.teacherScore);
              }
            });
            !paseint.test(teacherScore10) && teacherScore10 > 0
              ? (e.subTeacherScoreTotal = (teacherScore10 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore10);
          }
          if (e.key.types == 11) {
            let teacherScore11 = 0;
            e.value.forEach((i) => {
              if (i.teacherScore && i.teacherScore > 0) {
                teacherScore11 += Number(i.teacherScore);
              } //每个题型总得分
            });
            !paseint.test(teacherScore11) && teacherScore11 > 0
              ? (e.subTeacherScoreTotal = (teacherScore11 * 1).toFixed(2))
              : (e.subTeacherScoreTotal = teacherScore11);
          }
        })
        // 总分
        let sum = 0;
        this.subjectsList.forEach((e) => {
          e.value.forEach((item) => {
            let teacherScore = !paseint.test(item.teacherScore) && item.teacherScore > 0
              ? (item.teacherScore * 1).toFixed(2)
              : item.teacherScore;
            sum += Number(teacherScore);
          })
        })
        return sum.toFixed(2);
      }
    },
  },
  watch: {
    isSendWxMsg(newVal) {
      if (newVal == true && this.isPush == false) {
        this.$alert("勾选了发送微信消息将自动勾选【是否公布】！", "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          this.isPush = true;
        });
      }
    },
    isPush(newVal) {
      if (newVal == false && this.isSendWxMsg == true) {
        this.$alert("勾选了发送微信消息将自动勾选【是否公布】！", "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          this.isPush = true;
        });
      }
    },
  },
  created() {
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
    });
    setTimeout(() => {
      loading.close();
    }, 500);
    let query = this.getQueryParams(); //参数部分
    if (query) {
      this.examinationStudentId = query.examinationStudentId;
      this.loading = true;
      this.getExamPaper(this.examinationStudentId);
    }
  },
  mounted() {
    let style;
    if (
      this.$store.state &&
      this.$store.state.themeStyle &&
      this.$store.state.themeStyle.ThemeColor
    ) {
      style = JSON.parse(this.$store.state.themeStyle);
    }
    if (sessionStorage.getItem("themeStyle")) {
      style = JSON.parse(sessionStorage.getItem("themeStyle"));
    } else {
      style = defaultThemeStyle;
    }
    this.$nextTick(() => {
      document
        .querySelector("body")
        .setAttribute(
          "style",
          `--ThemeColor: ${style.ThemeColor || "#fd5252"};`
        );
    });
  },
  methods: {
    // 调用阿拉伯数字转中文数字方法
    convertToChineseNumeral,
    // 获取浏览器地址栏问号后的参数部分
    getQueryParams() {
      const queryParams = {};
      const hash = window.location.hash;
      const queryString = hash.substring(hash.indexOf('?') + 1); // 提取问号后的部分

      if (!queryString) {
        return queryParams; // 如果没有查询参数，直接返回空对象
      }

      const queryArray = queryString.split("&");
      for (let i = 0; i < queryArray.length; i++) {
        const keyValue = queryArray[i].split("=");
        const key = decodeURIComponent(keyValue[0]);
        const value = decodeURIComponent(keyValue[1] || "");
        queryParams[key] = value;
      }
      return queryParams;
    },
    // 获取待评阅考试记录
    async getExamPaper(id) {
      const res = await getReviewedsExamination(id);
      if (res && res.code == 1) {
        this.examPaper = res.result; //试卷内容
        this.examPaper.subjects.map((item) => {
          this.typeList.push(item.key);
        });
        // 试卷下试题组--Key为大题对象,Value为大题下小题集合对象
        this.subjectsList = JSON.parse(JSON.stringify(res.result.subjects)); //题
        // 获取滚动容器
        this.container = this.$refs.container;
        this.$nextTick(() => {
          this.stickyHeight = this.$refs.stickyElement.offsetHeight; //吸顶元素高度
          this.initRightBoxHeight();
        });
        this.$nextTick(() => {
          this.loading = false
          this.loadingText = "加载中...";
        })
      } else {
        this.$alert(res.message);
        this.$nextTick(() => {
          this.loading = false
        })
      }
    },
    /*计算每个小盒子高度*/
    initRightBoxHeight() {
      let itemArray = [];
      let top = 0;
      itemArray.push(top);
      //获取右边所有子盒子高度集合
      let allList = this.$refs.itemRefs;

      //allList伪数组转化成真数组
      Array.prototype.slice.call(allList).forEach((li) => {
        top += li.clientHeight; //获取所有li的每一个高度
        itemArray.push(top);
      });
      this.itemHeight = itemArray;
    },
    //题目区域滚动
    handleScroll() {
      this.scrollPosition = this.container.scrollTop; //滚动高度
      //判断锚点选中
      for (let index = 1; index < this.itemHeight.length; index++) {
        if (this.scrollPosition <= this.itemHeight[1]) {
          this.activeTab = 1;
        }
        if (
          this.scrollPosition >= this.itemHeight[index] &&
          this.scrollPosition <= this.itemHeight[index + 1]
        ) {
          this.activeTab = index + 1;
        }
      }
      // 修改需要吸顶元素的定位方式
      if (this.scrollPosition >= 70) {
        this.$set(this, "stickyStyle", { position: "fixed", width: "1200px" });
        this.$set(this, "borderBlue", {
          borderBottom: "1px solid  var(--ThemeColor)",
          width: "904px",
          margin: "20px 0 0 0",
          padding: "0 20px",
        });
        // 吸顶的宽度不受父元素控制，无法和滚动内容区域宽度一致并且水平居中，故用flex右侧给灰色盒子显隐，此方法使得吸顶和滚动内容宽度一致
        this.grayBoxShow = true;
      } else {
        this.$set(this, "stickyStyle", { position: "absolute" });
        this.$set(this, "borderBlue", {
          borderBottom: "1px solid #ebeced",
          width: "864px",
          margin: "20px 20px 0 20px",
        });
        this.grayBoxShow = false;
      }
    },
    // 锚点滚动
    scrollToSection(index) {
      let selectElementHeight = document.querySelector(
        `#section-${index}`
      ).offsetTop; // 要跳转元素到offsetParent顶部的距离
      this.container.scrollTo({
        top: selectElementHeight - this.stickyHeight,
        behavior: "smooth",
      });
    },
    // 退出评阅
    closeMark() {
      this.dialogVisible = true;
    },
    //退出
    exit() {
      window.close();
    },
    //
    changeSelect(arr) {
      arr.map((item) => {
        item.teacherScore = Number(item.teacherScore);
        if (item.types == 1) {
          this.arrtypes1 = arr;
        }
        if (item.types == 2) {
          this.arrtypes2 = arr;
        }
        if (item.types == 4) {
          this.arrtypes4 = arr;
        }
      });
    },
    //
    changeReadings(arr) {
      arr.forEach((item) => {
        item.teacherScore = Number(item.teacherScore);
        if (item.types == 9) {
          this.arrtypes9 = arr;
        }
        if (item.types == 10) {
          this.arrtypes10 = arr;
        }
      });
    }, //
    changeProgrammes(arr) {
      arr.forEach((item) => {
        item.teacherScore = Number(item.teacherScore);
        if (item.types == 3) {
          this.arrtypes3 = arr;
        }
        if (item.types == 11) {
          this.arrtypes11 = arr;
        }
      });
    }, //
    changeAnswers(arr) {
      arr.forEach((item) => {
        item.teacherScore = Number(item.teacherScore);
        if (item.types == 5) {
          this.arrtypes5 = arr;
        }
        if (item.types == 6) {
          this.arrtypes6 = arr;
        }
        if (item.types == 7) {
          this.arrtypes7 = arr;
        }
        if (item.types == 8) {
          this.arrtypes8 = arr;
        }
      });
    },
    submintMark() {
      this.dialogResult = true;
    },

    //提交评阅
    postDataMark() {
      this.dialogResult = false;
      let selectTypeArr = [];
      if (this.subjectsList && this.subjectsList.length > 0) {
        this.subjectsList.forEach((e) => {
          e.value.forEach((item) => {
            selectTypeArr.push(item)
          })
        })
      }
      // if (this.arrtypes1 && this.arrtypes1.length > 0) {
      //   this.arrtypes1.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes2 && this.arrtypes2.length > 0) {
      //   this.arrtypes2.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes3 && this.arrtypes3.length > 0) {
      //   this.arrtypes3.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes4 && this.arrtypes4.length > 0) {
      //   this.arrtypes4.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes5 && this.arrtypes5.length > 0) {
      //   this.arrtypes5.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes6 && this.arrtypes6.length > 0) {
      //   this.arrtypes6.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes7 && this.arrtypes7.length > 0) {
      //   this.arrtypes7.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes8 && this.arrtypes8.length > 0) {
      //   this.arrtypes8.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes9 && this.arrtypes9.length > 0) {
      //   this.arrtypes9.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes10 && this.arrtypes10.length > 0) {
      //   this.arrtypes10.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      // if (this.arrtypes11 && this.arrtypes11.length > 0) {
      //   this.arrtypes11.map((item) => {
      //     selectTypeArr.push(item);
      //   });
      // }
      this.submitPost(selectTypeArr);
    },
    async submitPost(selectTypeArr) {
      let data = {
        isPush: this.isPush,
        isSendWxMsg: this.isSendWxMsg,
        title: this.examPaper.title,
        examinationStudentId: this.examinationStudentId,
        subjects: selectTypeArr,
      };
      this.isDisabled = true;
      const res = await postReviewedsExamination(data);
      this.isDisabled = false;
      if (res && res.code == 1) {
        this.$alert(res.message, "提示", {
          confirmButtonText: "确定",
        }).then(() => {
          window.close();
        });
      } else {
        this.$alert(res.message, "提示", {
          confirmButtonText: "确定",
        }).then(() => { });
      }
    },
  },
};
</script>

<style scoped>
@import url("./markExamStyle.css");

#MarkExampapers ::v-deep .el-dialog {
  display: flex;
  flex-direction: column;
  margin: 0 !important;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 16px;
  transform: translate(-50%, -50%);
  max-height: calc(100% - 30px);
  max-width: calc(100% - 30px);
}

#MarkExampapers ::v-deep .el-dialog .el-dialog__body {
  flex: 1;
  overflow: auto;
}

#MarkExampapers ::v-deep el-input {
  z-index: -1;
}

.ft_btn>>>.el-button {
  width: 90%;
  line-height: 24px;
  margin: 0 auto;
  border-radius: 60px;
  color: #333;
  background-color: #ffd23e;
}

.ft_btn>>>.el-button:hover {
  color: #fff;
  background-color: #ffae02;
}

.two_checkbox::v-deep .el-checkbox__label {
  color: var(--ThemeColor);
}

.two_checkbox::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.two_checkbox::v-deep .el-checkbox__input.is-indeterminate .el-checkbox__inner {
  color: var(--ThemeColor);
  background-color: var(--ThemeColor);
  border-color: var(--ThemeColor);
}
</style>